import styled from 'styled-components';

const VSeparator = styled.div`
  width: ${({ width = '20px' }) => width};
  margin: ${({ margin = '0' }) => margin};
  flex: 0 0 ${({ width = '20px' }) => width};
`;

export default VSeparator;
